import React from 'react'
import { Grid, Typography } from '@material-ui/core';
import { useStyles } from './frameServices.module';

const FrameServices = (props) => {
    const classes = useStyles();

    return (
        <div>
            <Grid container spacing={2} className={
                props.isLastElement ? classes.frameServices : classes.frameServicesBorder
            }>

                <Grid
                    item
                    lg={2}
                    md={2}
                    sm={12}
                    xs={12}
                    className={classes.iconFrame}
                >
                    <img className={classes.imgFrame} src={props.srcFrame} alt={props.altFrame} />
                </Grid>
                <Grid
                    item
                    lg={10}
                    md={10}
                    sm={12}
                    xs={12}
                    className={classes.articleFrame}
                >
                    <Typography variant="subtitle1" className={classes.subtitleFrame}
                    >{props.subtitleFrame}</Typography>
                    <Typography className={classes.bodyFrame}
                    >{props.bodyFrame}</Typography>
                    {props.button}

                </Grid>
            </Grid>
        </div>
    )
}

export default FrameServices